module.exports = global["ZFRESPOND_JST"] = require("-!/root/project/node_modules/babel-loader/lib/index.js??ref--7-0!./legacy_zfrespond_jst.js");